<template>
  <div class="subsector metals">
    <div class="parent-sector">
      <p>Industrial Processes</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-6">
          <h1>Metals</h1>
          <div class="row">
            <div class="col-sm">
              <p>
                Emissions from metal production include PFCs emitted as
                by-products of aluminum production and SF₆ emitted from
                magnesium production.
              </p>
              <p>
                From 1990 through 2015, combined PFC and SF₆ emissions from
                metal production decreased by 68%. Emissions from metal
                production are projected to increase by 96% between 2015 and
                2030, with varying growth across emissions from aluminum
                production (103% increase) and magnesium production (40%
                increase). The metals source category emits 1% of the global
                baseline emissions in 2030, making this source a small emitter
                relative to the others.
              </p>
              <p>
                Metals production’s abatement potential is estimated to be
                approximately 28 MtCO₂e in 2030, or 39% of the source's baseline
                emissions. Break-even prices as low as $20/tCO₂e can achieve
                nearly half of the metals production’s mitigation potential, and
                a price of $5/tCO₂e can mitigate a quarter of metals emissions.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <p class="center">
            <button
              @click="
                switchComponent('ChartMetals1');
                activate(1);
              "
              :class="{ active: active_el == 1 }"
            >Projected Emissions</button>
            <button
              @click="
                switchComponent('ChartMetals2');
                activate(2);
              "
              :class="{ active: active_el == 2 }"
            >Reduction Potential</button>
          </p>

          <div class="container">
            <component v-bind:is="currentComp"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartMetals1 from "@/components/industrialprocesses/ChartMetals1";
import ChartMetals2 from "@/components/industrialprocesses/ChartMetals2";

export default {
  components: {
    ChartMetals1,
    ChartMetals2
  },
  data() {
    return {
      currentComp: "ChartMetals1",
      active_el: 1
    };
  },
  methods: {
    switchComponent(comp) {
      //alert("test comp: " + comp);
      return (this.currentComp = comp);
    },
    activate: function(el) {
      this.active_el = el;
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../../assets/bg-lightblue-bar.png") 0 0 repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}
.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.parent-sector {
  position: static;
  color: #012e51;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
}

.center button {
  position: static !important;
}
</style>
